<template>
  <div
    ref="emailEditor"
    class="receivers-list"
  >
    <template v-if="isVisible">
      <div
        class="text-input"
      >
        <label class="required-flag">{{ $t('to') }}</label>
        <textarea
          v-model.lazy="to"
          v-hkldinput
          v-autosize
          v-fusioninputcheck="{
          ...buildCheckerOptions(),
          required: true,
          }"
          :required="true"
        />
      </div>
      <div class="text-input">
        <label>{{ $t('cc') }}</label>
        <textarea
          v-model.lazy="cc"
          v-hkldinput
          v-autosize
          v-fusioninputcheck="{
          ...buildCheckerOptions(),
          required: cc.trim()
          }"
          :required="cc.trim()"
        />
      </div>
      <div class="text-input">
        <label>{{ $t('bcc') }}</label>
        <textarea
          v-model.lazy="bcc"
          v-hkldinput
          v-autosize
          v-fusioninputcheck="{
          ...buildCheckerOptions(),
          required: bcc.trim(),
          }"
          :required="bcc.trim()"
        />
      </div>
    </template>
  </div>
</template>

<script>
import { emailSeparator } from '@/api/postman/consts'
import { splitEmails, validateEmails } from '@/api/postman/util'
import { ref } from '@vue/composition-api'
import { useElementVisibility } from '@vueuse/core'
import { computed, getCurrentInstance, reactive, toRefs, unref } from 'vue-demi'

export default {
  model: {
    prop: 'emailReceivers',
    event: 'updateModel',
  },
  props: {
    emailReceivers: {
      type: Object,
      default: () => ({}),
    },
  },
  setup (props, { emit }) {
    const { proxy } = getCurrentInstance()
    const displaySeparator = emailSeparator + ' '
    const pendingReceivers = reactive({
      to: null,
      cc: null,
      bcc: null,
    })
    const useReceiverComputed = (key) => {
      return computed({
        get () {
          const rawData = props.emailReceivers[key]
          const result = splitEmails(rawData, emailSeparator)
          return result.join(displaySeparator)
        },
        set (val) {
          const newValue = Object.assign({}, refReceivers, { [key]: val })
          emit('updateModel', newValue)
        },
      })
    }
    const refReceivers = reactive({
      to: useReceiverComputed('to'),
      cc: useReceiverComputed('cc'),
      bcc: useReceiverComputed('bcc'),
    })
    const emailTipText = proxy.$t('hint.inputTip.email')
    const validateEmailsString = (val) => {
      const { result } = validateEmails(val)
      return result
    }
    const buildCheckerOptions = () => ({
      type: 'string',
      tip: unref(emailTipText),
      pattern: validateEmailsString,
      classes: 'tooltip-class',
    })

    const emailEditor = ref(null)
    return {
      isVisible: useElementVisibility(emailEditor),
      emailEditor,
      ...toRefs(refReceivers),
      pendingReceivers,
      emailTipText,
      buildCheckerOptions,
      validateEmailsString,
    }
  },
}
</script>

<style lang="scss" scoped>
@import '~styles/textField';
</style>
